// extracted by mini-css-extract-plugin
export default {"airplaneSizingContainer":"ica-z","narrowOptionButtons":"jca-z","noOptions":"kca-z"};